import { Tooltip as TooltipComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const Tooltip = styled(TooltipComponent)`
  display: inline-block;
  cursor: pointer;
`
